import { getPropertyValue } from '@tribeplatform/react-ui-kit/utils'

export const customizerPreviewScrollTo = (
  element: HTMLElement,
  document: Document,
) => {
  const offset =
    20 +
    parseInt(getPropertyValue(document, '--c-top-bar-height'), 10) +
    parseInt(getPropertyValue(document, '--frame-top-offset'), 10)
  const { top } = element.getBoundingClientRect()
  const _window = (element.getRootNode() as any).defaultView
  const y = top + _window.pageYOffset - offset
  _window.scrollTo({ top: y, behavior: 'smooth' })
}
